// Subscriptions due today (or overdue) shown at the top of the Orders list as
// print-only placeholders, so labels can go out in the morning. Nothing is
// written to the server: charging / logging the delivery later on the
// Subscribers page advances nextDeliveryDate, which drops the placeholder and
// the real Order takes its place.

const WEIGHT_RE = /^\d+(?:\.\d+)?\s*(?:g|kg|ml|l)$/i;
const COUNT_RE  = /^(?:x\s*(\d+)|(\d+)\s*x?)$/i;

export function isDueForPrint(sub, now = new Date()) {
  if (!sub?.nextDeliveryDate) return false;
  const endOfToday = new Date(now);
  endOfToday.setHours(23, 59, 59, 999);
  return new Date(sub.nextDeliveryDate) <= endOfToday;
}

// Sub items carry free-text quantity ("50g", "x2", "1 bunch"). Weights go into
// the name so PrintOrderModal's "Coriander 50g" parser picks them up; counts
// become label quantity; anything else is kept in brackets so it isn't lost.
export function subItemToOrderItem(item) {
  const q = (item.quantity || '').trim();
  if (!q) return { name: item.name, quantity: 1 };
  if (WEIGHT_RE.test(q)) return { name: `${item.name} ${q.replace(/\s+/g, '')}`, quantity: 1 };
  const count = q.match(COUNT_RE);
  if (count) return { name: item.name, quantity: Math.max(1, Number(count[1] || count[2])) };
  return { name: `${item.name} (${q})`, quantity: 1 };
}

export function subscriptionToPrintOrder(sub) {
  const c = sub.customerId || {};
  const items = sub.type === 'surprise' || !(sub.items || []).length
    ? [{ name: 'Surprise box', quantity: 1 }]
    : sub.items.map(subItemToOrderItem);
  return {
    _id:                  sub._id,
    isSubPlaceholder:     true,
    subscriptionPlanId:   sub._id,
    name:                 c.name || sub.label || 'Subscriber',
    email:                c.email,
    phone:                c.phone,
    timestamp:            sub.nextDeliveryDate,
    deliverySlot:         sub.deliverySlot,
    address:              sub.deliveryAddress,
    deliveryInstructions: sub.deliveryInstructions,
    billingMode:          sub.billingMode,
    items,
    total:                0,
  };
}

export function duePrintOrders(upcoming, now = new Date()) {
  return (upcoming || []).filter(s => isDueForPrint(s, now)).map(subscriptionToPrintOrder);
}
